import axios from "./axios";

import {
	getVehicles
} from '@/utils/auth'
//菜单查询
export const LoadVehicleTreeInfo = (data) => {
	return new Promise((resolve, reject) => {
		//从缓存中获取数据
		var v = getVehicles();
		if (v && v != "")
			resolve(JSON.parse(v));
		else {
			reject();
		}
	});
};

//更新车辆树
export const queryVehicleTreeInfo = (data) => {
	return axios({
		act: "v1/queryVehicleTreeInfo",
		method: "post",
		data,
	});
};

export const opelogin = (data) => {


	return axios({
		act: "v1/opelogin",
		method: "post",
		data,
	});
};
export const logout = (data) => {

	// return new Promise((resolve, reject) => {
	//     resolve({ code: 200 });
	// });
	return axios({
		act: "v1/logout",
		method: "post",
		data,
	});
};
export const queryDashBoardData = (data) => {


	return axios({
		act: "v1/queryLyDashboardData",
		method: "post",
		data,
	});
};

export const rechargelist = (data) => {

	return axios({
		act: "v1/rechargelist",
		method: "post",
		data,
	});
};

export const queryDashBoardChartData = (data) => {

	return axios({
		act: "v1/queryLyDashboardChartData",
		method: "post",
		data,
	});
};
//查询操作日志
export const queryOperatorLogList = (data) => {
	return axios({
		act: "v1/queryOperatorLogList",
		method: "post",
		data,
	});
};
//查询操作元列表
export const queryOperatorList = (data) => {
	return axios({
		act: "v1/queryOperatorList",
		method: "post",
		data,
	});
};
//删除操作元
export const deleteOperator = (data) => {
	return axios({
		act: "v1/deleteOperator",
		method: "post",
		data,
	});
};
export const reInitOpertator = (data) => {
	return axios({
		act: "v1/reInitOpertator",
		method: "post",
		data,
	});
};

//新增操作元
export const newOpertatorInfo = (data) => {
	return axios({
		act: "v1/newOpertatorInfo",
		method: "post",
		data,
	});
};

export const queryQuarterListOfOper = (data) => {
	return axios({
		act: "v1/queryQuarterListOfOper",
		method: "post",
		data,
	});
};

//角色信息查询
export const GetRoleOfOper = (data) => {
	return axios({
		act: "v1/getRoleOfOper",

		method: "post",
		data,
	});
};


//角色绑定功能菜单列表查询
export const GetRoleFunMenu = (data) => {
	return axios({
		act: "v1/getRole_FunMenu",
		method: "post",
		data,
	});
};

//保存角色信息
export const SaveRoleInfo = (data) => {
	return axios({
		act: "v1/saveRoleInfo",
		method: "post",
		data,
	});
};

//删除角色信息
export const DelRoleInfo = (data) => {
	return axios({
		act: "v1/delRoleInfo",
		method: "post",
		data,
	});
};

export const queryBindQuarterListOfOper = (data) => {
	return axios({
		act: "v1/queryBindQuarterListOfOper",
		method: "post",
		data,
	});
};
//获取所选车辆的里程统计图表
export const mileageChart = (data) => {
	return axios({
		act: "v1/mileageChart",
		method: "post",
		data
	})
}

//里程数据信息获取
export const mileageInfo = (data) => {
	return axios({
		act: "v1/mileageInfo",
		method: "post",
		data
	})
}

//获取所选车辆的开关门信息列表
export const doorsInfo = (data) => {
	return axios({
		act: "v1/doorsInfo",
		method: "post",
		data
	})
}
//下载所选车辆的开关门信息列表
export const doorsInfoDownload = (data) => {
	return axios({
		act: "v1/doorsInfo",
		method: "post",
		data,
		responseType: "blob"
	})
}
//获取所选车辆的能耗数据信息列表
export const energyInfo = (data) => {
	return axios({
		act: "v1/energyInfo",
		method: "post",
		data
	})
}
//获取所选车辆的能耗统计数据信息
export const energyStatistics = (data) => {
	return axios({
		act: "v1/energyStatistics",
		method: "post",
		data
	})
}
export const changePsw = (data) => {
	return axios({
		act: "v1/changePsw",
		method: "post",
		data
	})
}

//获取车辆基本信息
export const QueryVehicleBaseInfo = (data) => {


	return axios({
		act: "v1/vehicleinfo",
		method: "post",
		data
	})
};

export const realTimeVehicleInfo = (data) => {


	return axios({
		act: "v1/realTimeVehicleInfo",
		method: "post",
		data
	})
};





//查询车辆轨迹数据
export const QueryVehicleTrackInfo = (data) => {
	return axios({
		act: "v1/queryVehicleTrackInfo",
		method: "post",
		data
	})
};
//保存总公司信息
export const saveCompanyInfo = (data) => {

	return axios({
		act: "v1/saveCompanyInfo",
		method: "post",
		data
	})
};
//查询分公司列表
export const queryBranchInfo = (data) => {
	return axios({
		act: "v1/queryBranchInfo",
		method: "post",
		data
	})
};
//添加、修改、删除分公司
export const saveBranchInfo = (data) => {
	return axios({
		act: "v1/saveBranchInfo",
		method: "post",
		data
	})
};
//查询车队列表
export const queryFleetInfo = (data) => {
	return axios({
		act: "v1/queryFleetInfo",
		method: "post",
		data
	})
};
//查询线路列表
export const queryRouteList = (data) => {
	return axios({
		act: "v1/queryRouteList",
		method: "post",
		data
	})
};

//添加、修改、删除车队
export const saveFleetInfo = (data) => {
	return axios({
		act: "v1/saveFleetInfo",
		method: "post",
		data
	})
};

//添加、修改、删除线路
export const saveRouteInfo = (data) => {
	return axios({
		act: "v1/saveRouteInfo",
		method: "post",
		data
	})
};
//查询车辆信息列表
export const queryVehicleinfoList = (data) => {
	return axios({
		act: "v1/queryVehicleinfoList",
		method: "post",
		data
	})
};

//不良驾驶统计
export const driver = (data) => {
	return axios({
		act: "v1/driver",
		method: "post",
		data
	})
};
//查询车辆配件信息
export const queryAccessoriesinfoList = (data) => {
	return axios({
		act: "v1/queryAccessoriesinfoList",
		method: "post",
		data
	})
};

//获取报警的基本信息
export const alarmInfo = (data) => {
	return axios({
		act: "v1/alarmInfo",
		method: "post",
		data
	})
};
//获取报警的详细信息
export const alarmdetail = (data) => {
	return axios({
		act: "v1/alarmdetail",
		method: "post",
		data
	})
};
//获取故障的详细信息
export const FailureInfo = (data) => {
	return axios({
		act: "v1/FailureInfo",
		method: "post",
		data
	})
};
//获取故障占比的详细信息
export const FailureLevel = (data) => {
	return axios({
		act: "v1/FailureLevel",
		method: "post",
		data
	})
};
//获取车辆排名的详细信息
export const FailureRank = (data) => {
	return axios({
		act: "v1/FailureRank",
		method: "post",
		data
	})
};

//修改车辆信息
export const modifyVehicleInfo = (data) => {
	return axios({
		act: "v1/modifyVehicleInfo",
		method: "post",
		data
	})
};
//查询驾驶员
export const querydriver = (data) => {
	return axios({
		act: "v1/querydriver",
		method: "post",
		data
	})
};
//查询省份
export const queryProvince = (data) => {
	return axios({
		act: "v1/queryProvince",
		method: "post",
		data
	})
};
//查询市
export const queryCity = (data) => {
	return axios({
		act: "v1/queryCity",
		method: "post",
		data
	})
};
//新增驾驶员
export const newdriver = (data) => {
	return axios({
		act: "v1/newdriver",
		method: "post",
		data
	})
};
//车线绑定
export const bindcircuit = (data) => {
	return axios({
		act: "v1/bindcircuit",
		method: "post",
		data
	})
};
//车线绑定
export const bindRoute = (data) => {
	return axios({
		act: "v1/bindRoute",
		method: "post",
		data
	})
};
//查询总公司信息
export const headOfficeSearch = (data) => {
	return axios({
		act: "v1/headOfficeSearch",
		method: "post",
		data
	})
};
//限速控制信息
export const queryVehicleParamSetByOpID = (data) => {
	return axios({
		act: "v1/queryVehicleParamSetByOpID",
		method: "post",
		data
	})
};
//查询最高限速列表
export const queryMaxSpeedLawSet = (data) => {
	return axios({
		act: "v1/queryMaxSpeedLawSet",
		method: "post",
		data
	})
};
//设置最高限速
export const setMaxSpeed = (data) => {
	return axios({
		act: "v1/setMaxSpeed",
		method: "post",
		data
	})
};
//设置超速提醒
export const setOverSpeedRemind = (data) => {
	return axios({
		act: "v1/setOverSpeedRemind",
		method: "post",
		data
	})
};
//查询夜间限速列表
export const queryNightSpeedLimitSetRec = (data) => {
	return axios({
		act: "v1/queryNightSpeedLimitSetRec",
		method: "post",
		data
	})
};
//设置夜间限速
export const setFatigueDriving = (data) => {
	return axios({
		act: "v1/setFatigueDriving",
		method: "post",
		data
	})
};
//查询疲劳驾驶设置记录
export const queryFatigueDrivingSetRec = (data) => {
	return axios({
		act: "v1/queryFatigueDrivingSetRec",
		method: "post",
		data
	})
};

//查询区域限速控制的区域列表
export const querySpeedLimitArea = (data) => {
	return axios({
		act: "v1/querySpeedLimitArea",
		method: "post",
		data
	})
};
//保存区域信息
export const saveSpeedLimitArea = (data) => {
	return axios({
		act: "v1/saveSpeedLimitArea",
		method: "post",
		data
	})
};
//删除限速区域信息
export const removeSpeedLimitArea = (data) => {
	return axios({
		act: "v1/removeSpeedLimitArea",
		method: "post",
		data
	})
};
//5、查询区域设置的车辆列表
export const querySpeedLimitVehicleInfo = (data) => {
	return axios({
		act: "v1/querySpeedLimitVehicleInfo",
		method: "post",
		data
	})
};
//6、绑定车辆到区域
export const bindVehicleAndArea = (data) => {
	return axios({
		act: "v1/bindVehicleAndArea",
		method: "post",
		data
	})
};

//9、查询车辆绑定的区域列表
export const querySpeedLimitAreaByVID = (data) => {
	return axios({
		act: "v1/querySpeedLimitAreaByVID",
		method: "post",
		data
	})
};

//10、删除车辆绑定的区域
export const unbindVehicleAndArea = (data) => {
	return axios({
		act: "v1/unbindVehicleAndArea",
		method: "post",
		data
	})
};
//18、保存超速提醒区域 
export const saveOverSpeedRemindArea = (data) => {
	return axios({
		act: "v1/saveOverSpeedRemindArea",
		method: "post",
		data
	})
};
//20、绑定车辆到区域 （参数同6） 
export const bindVehicleAndOverSpeedRemindArea = (data) => {
	return axios({
		act: "v1/bindVehicleAndOverSpeedRemindArea",
		method: "post",
		data
	})
};

//19、获取柯设置区域的车辆列表，参数同5
export const queryOverSpeedRemindVehicleInfo = (data) => {
	return axios({
		act: "v1/queryOverSpeedRemindVehicleInfo",
		method: "post",
		data
	})
};
//32、获取道路等级限速提醒设置
export const queryCompOverSpeedConfig = (data) => {
	return axios({
		act: "v1/queryCompOverSpeedConfig",
		method: "post",
		data
	})
};
//33、保存道路登录限速提醒设置
export const saveCompOverSpeedConfig = (data) => {
	return axios({
		act: "v1/saveCompOverSpeedConfig",
		method: "post",
		data
	})
};

export const setNightSpeedLimit = (data) => {
	return axios({
		act: "v1/setNightSpeedLimit",
		method: "post",
		data
	})
};

//查询历史照片记录

export const queryHistoryPhotoList = (data) => {
	return axios({
		act: "v1/queryHistoryPhotoList",
		method: "post",
		data
	})
};


//事务提醒--需要维保车辆统计
export const maintananceStatistics = (data) => {
	return axios({
		act: "v1/maintananceStatistics",
		method: "post",
		data
	})
};
//事务提醒--维保车辆统计详细
export const maintananceStaDetail = (data) => {
	return axios({
		act: "v1/maintananceStaDetail",
		method: "post",
		data
	})
};
//事务提醒--维保车辆统计处理
export const maintananceDeal = (data) => {
	return axios({
		act: "v1/maintananceDeal",
		method: "post",
		data
	})
};
//事务提醒--维保车辆列表
export const maintananceInfo = (data) => {
	return axios({
		act: "v1/maintananceInfo",
		method: "post",
		data
	})
};

//事务提醒--查询提醒设置
export const queryDIYSet = (data) => {
	return axios({
		act: "v1/queryDIYSet",
		method: "post",
		data
	})
};
//事务提醒--维保历史记录
export const maintainRecordInfo = (data) => {
	return axios({
		act: "v1/maintainRecordInfo",
		method: "post",
		data
	})
};
//年检登记
export const annualInspectionInfo = (data) => {
	return axios({
		act: "v1/annualInspectionInfo",
		method: "post",
		data
	})
};
//新建或者编辑年检登记
export const annualInspectionSave = (data) => {
	return axios({
		act: "v1/annualInspectionSave",
		method: "post",
		data
	})
};
//删除年检登记
export const annualInspectionDel = (data) => {
	return axios({
		act: "v1/annualInspectionDel",
		method: "post",
		data
	})
};
//修改自定义设置
export const saveDIYInfo = (data) => {
	return axios({
		act: "v1/saveDIYInfo",
		method: "post",
		data
	})
};
//查询保险登记列表
export const insuranceInfo = (data) => {
	return axios({
		act: "v1/insuranceInfo",
		method: "post",
		data
	})
};
//新建/修改一条保险登记记录
export const insuranceSave = (data) => {
	return axios({
		act: "v1/insuranceSave",
		method: "post",
		data
	})
};
//删除一条保险登记记录
export const insuranceDel = (data) => {
	return axios({
		act: "v1/insuranceDel",
		method: "post",
		data
	})
};
//查询保养登记列表
export const maintainInfo = (data) => {
	return axios({
		act: "v1/maintainInfo",
		method: "post",
		data
	})
};
//新建/修改一条保养登记记录
export const maintainSave = (data) => {
	return axios({
		act: "v1/maintainSave",
		method: "post",
		data
	})
};
//删除一条保养登记记录
export const maintainDel = (data) => {
	return axios({
		act: "v1/maintainDel",
		method: "post",
		data
	})
};
//查询运营证年检/季检登记列表
export const inspectionY_QInfo = (data) => {
	return axios({
		act: "v1/inspectionY_QInfo",
		method: "post",
		data
	})
};
//新建运营证年检/季检登记记录
export const inspectionY_QAdd = (data) => {
	return axios({
		act: "v1/inspectionY_QAdd",
		method: "post",
		data
	})
};
//删除运营证年检/季检登记记录
export const inspectionY_QDel = (data) => {
	return axios({
		act: "v1/inspectionY_QDel",
		method: "post",
		data
	})
};
//工作年表
export const chronologyInfo = (data) => {
	return axios({
		act: "v1/chronologyInfo",
		method: "post",
		data
	})
};
//运行明细
export const runStateDetailInfo = (data) => {
	return axios({
		act: "v1/runStateDetailInfo",
		method: "post",
		data
	})
};
//运行日日/月统计 0:按月，1:按日查询
export const runStateInfo = (data) => {
	return axios({
		act: "v1/runStateInfo",
		method: "post",
		data
	})
};

//运行里程统计
export const runStateMileageInfo = (data) => {
	return axios({
		act: "v1/runStateMileageInfo",
		method: "post",
		data
	})
};
//运行日/月/整体汇总 0:按月，1:按日，2:整体
export const summaryInfo = (data) => {
	return axios({
		act: "v1/summaryInfo",
		method: "post",
		data
	})
};
//车辆驾驶评分
export const scoreInfo = (data) => {
	return axios({
		act: "v1/scoreInfo",
		method: "post",
		data
	})
};

//24、查询线路（分路段限速提醒）
export const queryLimitRouteInfo = (data) => {
	return axios({
		act: "v1/queryLimitRouteInfo",
		method: "post",
		data
	})
};

//23、保存线路（分路段限速提醒）
export const saveLimitRouteInfo = (data) => {
	return axios({
		act: "v1/saveLimitRouteInfo",
		method: "post",
		data
	})
};
//25、删除线路（分路段限速提醒）
export const delLimitRouteInfo = (data) => {
	return axios({
		act: "v1/delLimitRouteInfo",
		method: "post",
		data
	})
};

//31、解除全部车辆与线路的绑定（分路段限速）
export const removeAllVehicleAndRoute = (data) => {
	return axios({
		act: "v1/removeAllVehicleAndRoute",
		method: "post",
		data
	})
};

//29、绑定车辆到线路(分路段限速）
export const bindVehicleAndRoute = (data) => {
	return axios({
		act: "v1/bindVehicleAndRoute",
		method: "post",
		data
	})
};
//30、解除车辆与线路的绑定（分路段限速）
export const removeVehicleAndRoute = (data) => {
	return axios({
		act: "v1/removeVehicleAndRoute",
		method: "post",
		data
	})
};
//26、设置新路段（分路段限速提醒）
export const saveRoutePartInfo = (data) => {
	return axios({
		act: "v1/saveRoutePartInfo",
		method: "post",
		data
	})
};
//28、删除线路的所有路段（分路段限速）
export const delRoutePartInfo = (data) => {
	return axios({
		act: "v1/delRoutePartInfo",
		method: "post",
		data
	})
};
//28、查询线路绑定的车辆（分路段限速）
export const queryRoadVehicleList = (data) => {
	return axios({
		act: "v1/queryRoadVehicleList",
		method: "post",
		data
	})
};
//28、查询线路的路段（分路段限速）
export const queryRoadPartList = (data) => {
	return axios({
		act: "v1/queryRoadPartList",
		method: "post",
		data
	})
};
//28、查询线路的路段（分路段限速）
export const saveRouteLimitInfo = (data) => {
	return axios({
		act: "v1/saveRouteLimitInfo",
		method: "post",
		data
	})
};
//获取验证码
export const sendVerificationCode = (data) => {
	return axios({
		act: "v1/sendVerificationCode",
		method: "post",
		data
	})
};

//绑定手机号
export const bindMobile = (data) => {
	return axios({
		act: "v1/bindMobile",
		method: "post",
		data
	})
};
//修改弱密码
export const changePswByMobile = (data) => {
	return axios({
		act: "v1/changePswByMobile",
		method: "post",
		data
	})
};
//维修主表查询/下载接口
export const queryMMInfoByComID = (data) => {
	return axios({
		act: "v1/queryMMInfoByComID",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//查询维修工时附表及维修配件附表接口
export const queryMMPartAndWorkHourInfo = (data) => {
	return axios({
		act: "v1/queryMMPartAndWorkHourInfo",
		method: "post",
		data
	})
};
//新建维修信息、修改维修信息、删除维修信息
export const saveMMInfo = (data) => {
	return axios({
		act: "v1/saveMMInfo",
		method: "post",
		data
	})
};
//新建、修改、删除维修工时附表
export const saveMMWorkHourInfo = (data) => {
	return axios({
		act: "v1/saveMMWorkHourInfo",
		method: "post",
		data
	})
};

//新建、修改、删除维修配件附表
export const saveMMPartInfo = (data) => {
	return axios({
		act: "v1/saveMMPartInfo",
		method: "post",
		data
	})
};

//事故管理，查询/下载事故列表接口
export const queryAccidentInfo = (data) => {
	return axios({
		act: "v1/queryAccidentInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//事故管理，添加、修改、删除事故登记
export const saveAccidentInfo = (data) => {
	return axios({
		act: "v1/saveAccidentInfo",
		method: "post",
		data
	})
};
//事故统计，查询/下载事故统计列表日统计接口
export const statDayAccidentInfo = (data) => {
	return axios({
		act: "v1/statDayAccidentInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//事故统计，查询/下载事故统计列表月统计接口
export const statMonthAccidentInfo = (data) => {
	return axios({
		act: "v1/statMonthAccidentInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//事故统计，查询/下载整体日汇总事故统计列表接口
export const statDayAccidentInfoCollect = (data) => {
	return axios({
		act: "v1/statDayAccidentInfoCollect",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//事故统计，查询/下载整体月汇总事故统计列表接口
export const statMonthAccidentInfoCollect = (data) => {
	return axios({
		act: "v1/statMonthAccidentInfoCollect",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//事故统计，查询/下载整体整体汇总事故统计列表接口
export const statWholeAccidentInfoCollect = (data) => {
	return axios({
		act: "v1/statWholeAccidentInfoCollect",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//违章列表查询/下载接口
export const queryPeccancyInfo = (data) => {
	return axios({
		act: "v1/queryPeccancyInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//添加、修改、删除违章信息
export const savePeccancyInfo = (data) => {
	return axios({
		act: "v1/savePeccancyInfo",
		method: "post",
		data
	})
};
//用于查询/下载违章日统计列表
export const statDayPeccancyInfo = (data) => {
	return axios({
		act: "v1/statDayPeccancyInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//用于查询/下载违章月统计列表
export const statMonthPeccancyInfo = (data) => {
	return axios({
		act: "v1/statMonthPeccancyInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//用于查询/下载违章整体日汇总统计列表

export const statDayPeccancyInfoCollect = (data) => {
	return axios({
		act: "v1/statDayPeccancyInfoCollect",
		method: "post",
		data,
		responseType: 'blob'
	})
};
export const statMonthPeccancyInfoCollect = (data) => {
	return axios({
		act: "v1/statMonthPeccancyInfoCollect",
		method: "post",
		data,
		responseType: 'blob'
	})
};
export const statWholePeccancyInfoCollect = (data) => {
	return axios({
		act: "v1/statWholePeccancyInfoCollect",
		method: "post",
		data,
		responseType: 'blob'
	})
};
export const queryDriverInfo = (data, responseType = 'blob') => {
	return axios({
		act: "v1/queryDriverInfo",
		method: "post",
		data,
		responseType: responseType
	})
};
export const saveDriverInfo = (data) => {
	return axios({
		act: "v1/saveDriverInfo",
		method: "post",
		data
	})
};
//视频接口请求
export const videoStreamControl = (data) => {
	return axios({
		act: "v1/videoStreamControl",
		method: "post",
		data
	})
};

//查询简报页面当天数据
export const VelCalcData = (data) => {
	return axios({
		act: "v1/VelCalcData",
		method: "post",
		data
	})
};
//操作日志
export const QueryOpeLog = (data) => {
	return axios({
		act: "v1/QueryOpeLog",
		method: "post",
		data
	})
};
//登录日志
export const QueryLoginLog = (data) => {
	return axios({
		act: "v1/QueryLoginLog",
		method: "post",
		data
	})
};

//故障查询详细下载
export const downloadFailureInfo = (data) => {
	return axios({
		act: "v1/FailureInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};

//菜单访问记录
export const addMenuLog = (data) => {
	return axios({
		act: "v1/addMenuLog",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//里程导出
export const downMileageInfo = (data) => {
	return axios({
		act: "v1/mileageInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//能耗导出
export const downEnergyInfo = (data) => {
	return axios({
		act: "v1/energyInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//运行明细导出
export const downRunStateDetailInfo = (data) => {
	return axios({
		act: "v1/runStateDetailInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//运行日/月统计下载
export const downRunStateInfo = (data) => {
	return axios({
		act: "v1/runStateInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//运行里程统计下载
export const downRunStateMileageInfo = (data) => {
	return axios({
		act: "v1/runStateMileageInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//运行汇总下载
export const downSummaryInfo = (data) => {
	return axios({
		act: "v1/summaryInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//运行月利用率下载
export const downMonthUseInfo = (data) => {
	return axios({
		act: "v1/monthUseInfo",
		method: "post",
		data,
		responseType: 'blob'
	})
};
//查询隐私政策
export const QueryPrivacyPolicy = (data) => {
	return axios({
		act: "v1/QueryPrivacyPolicy",
		method: "post",
		data
	})
};

//查询视频设备
export const queryVideoDeviceNoByOptID = (data) => {
	return axios({
		act: "v1/queryVideoDeviceNoByOptID",
		method: "post",
		data,
	});
};

//查询充电设置记录 queryLastChargeRemind
export const queryLastChargeRemind = (data) => {
	return axios({
		act: "v1/queryLastChargeRemind",
		method: "post",
		data,
	});
};
//保存充电设置记录 setChargeRemind
export const setChargeRemind = (data) => {
	return axios({
		act: "v1/setChargeRemind",
		method: "post",
		data,
	});
};

export const VehicleChargeRec = (data, responseType) => {
	return axios({
		act: "v1/VehicleChargeRec",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
}
export const VehicleChargeRecGraph = (data) => {
	return axios({
		act: "v1/VehicleChargeRecGraph",
		method: "post",
		data,
	});
}
export const queryWebHomeOverview = (data) => {
	return axios({
		act: "v1/queryWebHomeOverview",
		method: "post",
		data,
	});
}

//空调预约记录查询
export const queryRemoteControlACRecord = (data) => {
	return axios({
		act: "v1/queryRemoteControlACRecord",
		method: "post",
		data,
	});
}
//车辆远程控制
export const realtimeControl = (data) => {
	return axios({
		act: "v1/realtimeControl",
		method: "post",
		data,
	});
}
//获取实时信息
export const queryRealTimeVehicleInfo = (data) => {
	return axios({
		act: "v1/queryRealTimeVehicleInfo",
		method: "post",
		data,
	});
}
//查询上一次预约状态
export const queryRemoteControlACStatus = (data) => {
	return axios({
		act: "v1/queryRemoteControlACStatus",
		method: "post",
		data,
	});
}

//握手1
export const handshake1 = (data) => {
	return axios({
		act: "v1/handshake1",
		method: "post",
		data,
	});
}
//握手2
export const handshake2 = (data) => {
	return axios({
		act: "v1/handshake2",
		method: "post",
		data,
	});
}
//登录RSA
export const applogin = (data) => {
	return axios({
		act: "v1/applogin",
		method: "post",
		data,
	});
}
export const applogin3 = (data) => {
	return axios({
		act: "v1/applogin3",
		method: "post",
		data,
	});
}

//空调统计
export const queryAirEnergyInfoWeb = (data, responseType) => {
	return axios({
		act: "v1/queryAirEnergyInfoWeb",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
}
export const queryAirEnergyInfoWebMY = (data, responseType) => {
	return axios({
		act: "v1/queryAirEnergyInfoWebMY",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
}
//空调预约控制
export const remoteControlAC = (data) => {
	return axios({
		act: "v1/remoteControlAC",
		method: "post",
		data,
	});
}

//报警前十排名
export const queryVehicleAlarmRanking = (data) => {
	return axios({
		act: "v1/queryVehicleAlarmRanking",
		method: "post",
		data,
	});
}
//查询车辆预热
export const queryPreHeatSettingInfo = (data) => {
	return axios({
		act: "v1/queryPreHeatSettingInfo",
		method: "post",
		data,
	});
}
//查看车辆预热执行记录
export const queryPreHeatSettingDetail = (data) => {
	return axios({
		act: "v1/queryPreHeatSettingDetail",
		method: "post",
		data,
	});
}
//新增预热、取消预约

export const savePreHeatSettingInfo = (data) => {
	return axios({
		act: "v1/savePreHeatSettingInfo",
		method: "post",
		data,
	});
}
//查询加油、加氢、充电记录
export const queryOilInfoNew = (data) => {
	return axios({
		act: "v1/queryOilInfoNew",
		method: "post",
		data,
	});
}
//新增加油、加氢、充电记录
export const saveOilInfoNew = (data) => {
	return axios({
		act: "v1/saveOilInfoNew",
		method: "post",
		data,
	});
}
//上传照片预处理
export const uploadFile = (data) => {
	return axios({
		act: "v1/uploadFile",
		method: "post",
		data,
	});
}
//新增、删除路费
export const saveCostInfoNew = (data) => {
	return axios({
		act: "v1/saveCostInfoNew",
		method: "post",
		data,
	});
}
//查询路费
export const queryCostInfoNew = (data) => {
	return axios({
		act: "v1/queryCostInfoNew",
		method: "post",
		data,
	});
}
//查询某辆车某段日期时间的行程
export const queryWebDrivingScoreTrip = (data) => {
	return axios({
		act: "v1/queryWebDrivingScoreTrip",
		method: "post",
		data,
	});
}
//驾驶评分统计
export const queryWebDrivingScore = (data, responseType) => {
	return axios({
		act: "v1/queryWebDrivingScore",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
}
//驾驶评分统计详情
export const queryWebDrivingScoreDetail = (data) => {
	return axios({
		act: "v1/queryWebDrivingScoreDetail",
		method: "post",
		data,
	});
}
//查询默认巡检设置
export const queryInspectionDefault = (data) => {
	return axios({
		act: "v1/queryInspectionDefault",
		method: "post",
		data,
	});
}
//保存巡检配置
export const saveInspectionDefault = (data) => {
	return axios({
		act: "v1/saveInspectionDefault",
		method: "post",
		data,
	});
}
//增删改单个巡检项
export const saveInspectionItem = (data) => {
	return axios({
		act: "v1/saveInspectionItem",
		method: "post",
		data,
	});
}
// 查询车辆巡检记录接口
export const queryInspectionRecord = (data) => {
	return axios({
		act: "v1/queryInspectionRecord",
		method: "post",
		data,
	});
}
// 查询车辆巡检记录接口
export const queryInspectionRecordWeb = (data) => {
	return axios({
		act: "v1/queryInspectionRecordWeb",
		method: "post",
		data,
	});
}
// 下载车辆巡检记录接口
export const downqueryInspectionRecordWeb = (data) => {
	return axios({
		act: "v1/queryInspectionRecordWeb",
		method: "post",
		data,
		responseType: "blob"
	});
}
//查巡检详情
export const queryInspectionRecordDetails = (data) => {
	return axios({
		act: "v1/queryInspectionRecordDetails",
		method: "post",
		data,
	});
}
//外观巡检详情
export const queryInspectionRecordDetailsEx = (data) => {
	return axios({
		act: "v1/queryInspectionRecordDetailsEx",
		method: "post",
		data,
	});
}
//意见反馈
export const queryOpinionFeedback = (data) => {
	return axios({
		act: "v1/queryOpinionFeedback",
		method: "post",
		data,
	});
}
//意见反馈
export const saveOpinionFeedback = (data) => {
	return axios({
		act: "v1/saveOpinionFeedback",
		method: "post",
		data,
	});
}

//点击运行分析
export const queryMotorInfo = (data) => {
	return axios({
		act: "v1/queryMotorInfo",
		method: "post",
		data,
	});
}
export const getMenuByOptID = (data) => {
	return axios({
		act: "v1/getMenuByOptID",
		method: "post",
		data,
	});
}
//节油驾驶评分
export const queryFuelEffiGradeScoreBadDrivingDetails = (data) => {
	return axios({
		act: "v1/queryFuelEffiGradeScoreBadDrivingDetails",
		method: "post",
		data,
	});
}
export const queryFuelEffiGradeScoreDashboard = (data) => {
	return axios({
		act: "v1/queryFuelEffiGradeScoreDashboard",
		method: "post",
		data,
	});
}
export const queryFuelEffiGradeScoreRankings = (data) => {
	return axios({
		act: "v1/queryFuelEffiGradeScoreRankings",
		method: "post",
		data,
	});
}
export const queryFuelEffiGradeScoreTrend = (data) => {
	return axios({
		act: "v1/queryFuelEffiGradeScoreTrend",
		method: "post",
		data,
	});
}
export const queryFuelEffiGradeScoreRunRec = (data) => {
	return axios({
		act: "v1/queryFuelEffiGradeScoreRunRec",
		method: "post",
		data,
	});
}
export const queryFuelEffiGradeScoreBadDriving = (data) => {
	return axios({
		act: "v1/queryFuelEffiGradeScoreBadDriving",
		method: "post",
		data,
	});
}
export const queryFieldListByFunction = (data, responseType) => {
	return axios({
		act: "v1/queryFieldListByFunction",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};
export const setEmergencyAlert = (data) => {
	return axios({
		act: "v1/setEmergencyAlert",
		method: "post",
		data,
	});
};
export const queryEmergencyAlert = (data) => {
	return axios({
		act: "v1/queryEmergencyAlert",
		method: "post",
		data,
	});
};
//增删改SIM卡充值负责人联系方式
export const saveBriefInfo = (data) => {
	return axios({
		act: "v1/saveBriefInfo",
		method: "post",
		data,
	})
}
//查SIM卡充值负责人联系方式
export const queryBriefInfo = (data) => {
	return axios({
		act: "v1/queryBriefInfo",
		method: "post",
		data,
	})
}
//查询申请记录
export const queryBasicInfo = (data) => {
	return axios({
		act: "v1/queryBasicInfo",
		method: "post",
		data,
	})
}
//查询基础信息
export const getBasicInfo = (data) => {
	return axios({
		act: "v1/getBasicInfo",
		method: "post",
		data,
	})
}
//增删改基本信息
export const saveBasicInfo = (data) => {
	return axios({
		act: "v1/saveBasicInfo",
		method: "post",
		data,
	})
}
//车牌号和SIM卡号对应关系
export const getMobileByVID = (data) => {
	return axios({
		act: "v1/getMobileByVID",
		method: "post",
		data,
	})
}
//增删改续费信息
export const saveChargeApplyInfo = (data) => {
	return axios({
		act: "v1/saveChargeApplyInfo",
		method: "post",
		data,
	})
}
//提交续费信息
export const submitApply = (data) => {
	return axios({
		act: "v1/submitApply",
		method: "post",
		data,
	})
}
//保存充值记录
export const saveBankRecordInfo = (data) => {
	return axios({
		act: "v1/saveBankRecordInfo",
		method: "post",
		data,
	})
}
export const queryChargeApplyInfo = (data) => {
	return axios({
		act: "v1/queryChargeApplyInfo",
		method: "post",
		data,
	})
}
export const queryBankRecordInfo = (data) => {
	return axios({
		act: "v1/queryBankRecordInfo",
		method: "post",
		data,
	})
}

export const querySpeedLimitRecords = (data) => {
	return axios({
		act: "v1/querySpeedLimitRecords",
		method: "post",
		data,
	})
}
//车辆超时离站记录查询
export const queryVehicleOverstayRecords = (data) => {
	return axios({
		act: "v1/queryVehicleOverstayRecords",
		method: "post",
		data,
	})
}
export const setTemplateConfigApp = (data) => {
	return axios({
		act: "v1/setTemplateConfigApp",
		method: "post",
		data,
	})
}
export const queryTemplateConfigApp = (data) => {
	return axios({
		act: "v1/queryTemplateConfigApp",
		method: "post",
		data,
	})
}
export const queryParkingRecord = (data, responseType) => {
	return axios({
		act: "v1/queryParkingRecord",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
}
export const QueryConsumpVsMileage = (data) => {
	return axios({
		act: "v1/QueryConsumpVsMileage",
		method: "post",
		data,
	})
}
//查询车辆最新GPS信息
export const QueryVehicleLastGpsMulti = (data) => {
	return axios({
		act: "v1/queryVehicleLastGpsMulti",
		method: "post",
		data,
	})
}
//查询维保列表， 输入参数：Vehicles，VehicleModel，Language，PageNo，PageSize，IsExport，IsRead
export const MaintananceSingleReminder = (data, responseType) => {
	return axios({
		act: "v1/maintananceSingleReminder",
		method: "post",
		data,
		responseType: responseType || 'json'
	})
}
//查询维保详情 输入参数： Vehicles ，VehicleModel ，Language ，Marker ，PageNo ，PageSize
export const MaintananceReminderDetails = (data) => {
	return axios({
		act: "v1/maintananceReminderDetails",
		method: "post",
		data,
	})
}
//批量读取维保记录
export const maintanancePatchRead = (data) => {
	return axios({
		act: "v1/maintanancePatchRead",
		method: "post",
		data,
	})
}
//  不良驾驶明细
export const VehicleBadnessDetail = (data, responseType) => {
	return axios({
		act: "v1/VehicleBadnessDetail",
		method: "post",
		data,
		responseType: responseType || 'json'
	})
}
//查询车辆日能耗信息
export const queryAirEnergyInfoDaily = (data, responseType) => {
	return axios({
		act: "v1/queryAirEnergyInfoDaily",
		method: "post",
		data,
		responseType: responseType || 'json'
	})
}
export const queryAirEnergyInfoDailyMY = (data, responseType) => {
	return axios({
		act: "v1/queryAirEnergyInfoDailyMY",
		method: "post",
		data,
		responseType: responseType || 'json'
	})
}

export const useGoogleMap = (data, responseType) => {
	return axios({
		act: "v1/useGoogleMap",
		method: "post",
		data,
		responseType: responseType || 'json'
	})
}
export default {
	useGoogleMap,
	queryAirEnergyInfoDaily,
	queryAirEnergyInfoDailyMY,
	VehicleBadnessDetail,
	maintanancePatchRead,
	MaintananceReminderDetails,
	MaintananceSingleReminder,
	QueryVehicleLastGpsMulti,
	QueryConsumpVsMileage,
	queryParkingRecord,
	queryTemplateConfigApp,
	setTemplateConfigApp,
	queryEmergencyAlert,
	setEmergencyAlert,
	queryFieldListByFunction,
	queryFuelEffiGradeScoreBadDriving,
	queryFuelEffiGradeScoreRunRec,
	queryFuelEffiGradeScoreTrend,
	queryFuelEffiGradeScoreRankings,
	queryFuelEffiGradeScoreDashboard,
	queryFuelEffiGradeScoreBadDrivingDetails,
	getMenuByOptID,
	queryMotorInfo,
	saveOpinionFeedback,
	queryOpinionFeedback,
	queryVehicleAlarmRanking,
	remoteControlAC,
	queryAirEnergyInfoWeb,
	queryAirEnergyInfoWebMY,
	applogin,
	applogin3,
	handshake2,
	handshake1,
	queryRemoteControlACStatus,
	queryRealTimeVehicleInfo,
	realtimeControl,
	queryRemoteControlACRecord,
	queryWebHomeOverview,
	VehicleChargeRecGraph,
	VehicleChargeRec,
	setChargeRemind,
	queryLastChargeRemind,
	queryVideoDeviceNoByOptID,
	QueryPrivacyPolicy,
	downMonthUseInfo,
	downSummaryInfo,
	downRunStateMileageInfo,
	downRunStateInfo,
	downRunStateDetailInfo,
	downEnergyInfo,
	downMileageInfo,
	addMenuLog,
	downloadFailureInfo,
	QueryLoginLog,
	QueryOpeLog,
	doorsInfoDownload,
	VelCalcData,
	videoStreamControl,
	scoreInfo,
	saveRouteLimitInfo,
	queryRoadPartList,
	queryRoadVehicleList,
	delRoutePartInfo,
	saveRoutePartInfo,
	removeVehicleAndRoute,
	bindVehicleAndRoute,
	removeAllVehicleAndRoute,
	delLimitRouteInfo,
	saveLimitRouteInfo,
	queryLimitRouteInfo,
	summaryInfo,
	runStateMileageInfo,
	runStateInfo,
	runStateDetailInfo,
	chronologyInfo,
	inspectionY_QDel,
	inspectionY_QAdd,
	inspectionY_QInfo,
	maintainDel,
	maintainSave,
	maintainInfo,
	insuranceDel,
	insuranceSave,
	insuranceInfo,
	queryVehicleTreeInfo,
	queryHistoryPhotoList,
	setNightSpeedLimit,

	saveDIYInfo,
	annualInspectionDel,
	annualInspectionSave,
	annualInspectionInfo,
	maintainRecordInfo,
	queryDIYSet,
	maintananceInfo,
	maintananceDeal,
	maintananceStaDetail,
	maintananceStatistics,

	saveCompOverSpeedConfig,
	queryCompOverSpeedConfig,
	queryOverSpeedRemindVehicleInfo,
	bindVehicleAndOverSpeedRemindArea,
	saveOverSpeedRemindArea,
	unbindVehicleAndArea,
	querySpeedLimitAreaByVID,
	bindVehicleAndArea,
	querySpeedLimitVehicleInfo,
	removeSpeedLimitArea,
	saveSpeedLimitArea,
	querySpeedLimitArea,
	queryFatigueDrivingSetRec,
	setFatigueDriving,
	queryNightSpeedLimitSetRec,
	setOverSpeedRemind,
	setMaxSpeed,
	queryMaxSpeedLawSet,
	queryVehicleParamSetByOpID,
	realTimeVehicleInfo,
	rechargelist,
	QueryVehicleTrackInfo,
	QueryVehicleTrackInfo,
	queryBindQuarterListOfOper,
	newOpertatorInfo,
	queryQuarterListOfOper,
	reInitOpertator,
	deleteOperator,
	queryOperatorList,
	queryOperatorLogList,
	logout,
	queryDashBoardData,
	queryDashBoardChartData,
	changePsw,
	opelogin,
	QueryVehicleBaseInfo,
	LoadVehicleTreeInfo,
	GetRoleOfOper,
	GetRoleFunMenu,
	SaveRoleInfo,
	DelRoleInfo,
	mileageChart,
	mileageInfo,
	doorsInfo,
	energyInfo,
	energyStatistics,
	saveCompanyInfo,
	queryBranchInfo,
	saveBranchInfo,
	queryFleetInfo,
	queryRouteList,
	saveFleetInfo,
	saveRouteInfo,
	queryVehicleinfoList,
	driver,
	alarmInfo,
	alarmdetail,
	FailureInfo,
	FailureLevel,
	FailureRank,
	queryAccessoriesinfoList,
	modifyVehicleInfo,
	querydriver,
	queryProvince,
	queryCity,
	newdriver,
	bindcircuit,
	bindRoute,
	headOfficeSearch,
	sendVerificationCode,
	bindMobile,
	changePswByMobile,
	queryMMInfoByComID,
	queryMMPartAndWorkHourInfo,
	saveMMInfo,
	saveMMWorkHourInfo,
	saveMMPartInfo,
	queryAccidentInfo,
	saveAccidentInfo,
	statDayAccidentInfo,
	statMonthAccidentInfo,
	statDayAccidentInfoCollect,
	statMonthAccidentInfoCollect,
	statWholeAccidentInfoCollect,
	queryPeccancyInfo,
	savePeccancyInfo,
	statDayPeccancyInfo,
	statMonthPeccancyInfo,
	statDayPeccancyInfoCollect,
	statMonthPeccancyInfoCollect,
	statWholePeccancyInfoCollect,
	queryDriverInfo,
	saveDriverInfo,
	queryPreHeatSettingInfo,
	queryPreHeatSettingDetail,
	savePreHeatSettingInfo,
	queryOilInfoNew,
	saveOilInfoNew,
	uploadFile,
	saveCostInfoNew,
	queryCostInfoNew,
	queryWebDrivingScoreTrip,
	queryWebDrivingScore,
	queryWebDrivingScoreDetail,
	queryInspectionDefault,
	saveInspectionDefault,
	saveInspectionItem,
	queryInspectionRecord,
	queryInspectionRecordWeb,
	queryInspectionRecordDetails,
	queryInspectionRecordDetailsEx,
	downqueryInspectionRecordWeb,
	saveBriefInfo,
	queryBriefInfo,
	queryBasicInfo,
	getBasicInfo,
	saveBasicInfo,
	getMobileByVID,
	saveChargeApplyInfo,
	submitApply,
	saveBankRecordInfo,
	queryChargeApplyInfo,
	queryBankRecordInfo,
	querySpeedLimitRecords,
	queryVehicleOverstayRecords

}